import { components } from "@certn/legacy-api/generated-schemas/people";
import { t } from "i18next";
import { array, object, string } from "yup";

import { NameInputField } from "./NameInputField";
import { NameSummaryField } from "./NameSummaryField";
import { FieldType } from "../types";

export function NameField(
  field: components["schemas"]["NameCheckField"]
): FieldType<components["schemas"]["NameCheckField"]> {
  return {
    field,
    inputElement: <NameInputField key={field.name} field={field} />,
    summaryElement: () => <NameSummaryField key={field.name} field={field} />,
    schema: nameFieldSchema,
    initialValue:
      field.value.length > 0
        ? field.value.sort(({ type }) => (type === "PRIMARY" ? -1 : 1))
        : [
            {
              first_name: "",
              last_name: "",
              middle_name: "",
              type: "PRIMARY",
            },
          ],
  };
}

// 1+ letters with spaces, apostrophes and hyphens allowed anywhere except first and last character
const validNameRegex = /^((\p{L}+)|(\p{L}[\p{L}\s'-]*\p{L}))$/u;
const validationText = t("Please only use letters and numbers");

export const nameFieldSchema = array().of(
  object().shape({
    first_name: string().when(["type"], ([type], schema) => {
      if (["PRIMARY", "FORMER", "ALIAS"].find((t) => t === type)) {
        return schema
          .trim()
          .required()
          .label(t("First name"))
          .matches(validNameRegex, validationText);
      }

      return schema;
    }),
    middle_name: string().trim().matches(validNameRegex, validationText),
    last_name: string().when(["type"], ([type], schema) => {
      if (["PRIMARY", "FORMER", "MAIDEN"].find((t) => t === type)) {
        return schema
          .trim()
          .required()
          .label(t("Last name"))
          .matches(validNameRegex, validationText);
      }

      return schema;
    }),
    type: string().required().label(t("Name type")),
  })
);
